export default {
  // template 页面模板
  getNavs: () => {
    return [
      // 花园
      {
        lable: 'Gardens',
        products: [
          {
            name: 'igs-01',
            id: 'igs-01',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-01.png',
          },
          {
            name: 'igs-01se',
            id: 'igs-01se',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-01se.png',
          },
          {
            name: 'igs-02',
            id: 'igs-02',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-02.png',
          },
          {
            name: 'igs-05',
            id: 'igs-05',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-05.png',
          },
          {
            name: 'igs-06',
            id: 'igs-06',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-06.png',
          },
          {
            name: 'igs-09',
            id: 'igs-09',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-09.png',
          },
          {
            name: 'igs-10',
            id: 'igs-10',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-10.png',
          },
          {
            name: 'igs-11',
            id: 'igs-11',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-11.png',
          },
          {
            name: 'igs-12',
            id: 'igs-12',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-12.png',
          },
          {
            name: 'igs-13',
            id: 'igs-13',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-13.png',
          },
          {
            name: 'igs-14',
            id: 'igs-14',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-14.png',
          },
          {
            name: 'igs-20',
            id: 'igs-20',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-20.png',
          },
          {
            name: 'igs-20se',
            id: 'igs-20se',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-20se.png',
          },
          {
            name: 'igs-25se',
            id: 'igs-25se',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-25se.png',
          },
          {
            name: 'igs-27',
            id: 'igs-27',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-27.png',
          },
          {
            name: 'igs-28se',
            id: 'igs-28se',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-28.png',
          },
          {
            name: 'igs-29',
            id: 'igs-29',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-29.png',
          },
          {
            name: 'igs-36',
            id: 'igs-36',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-36.png',
          },
          {
            name: 'igs-37se',
            id: 'igs-37se',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-37se.png',
          },
          {
            name: 'igs-38',
            id: 'igs-38',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-38.png',
          },
          {
            name: 'igs-39',
            id: 'igs-39',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-39.png',
          },
          {
            name: 'igs-60',
            id: 'igs-60',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-60.png',
          },
          {
            name: 'igs-70',
            id: 'igs-70',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/shuipei/igs-70.png',
          },
          {
            name: 'igs-71',
            id: 'igs-71',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/shuipei/product-igs-71/IGS-71-shitu/IGS-71-zhengshitu.png',
          },
        ],
      },
      //   补光灯
      {
        lable: 'Led Grow Lights',
        products: [
          {
            name: 'igs-21',
            id: 'igs-21',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/buguangdeng/igs-21.1.png',
          },
          {
            name: 'igs-22',
            id: 'igs-22',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/buguangdeng/igs-22.1.png',
          },
          {
            name: 'igs-31',
            id: 'igs-31',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/buguangdeng/igs-31.png',
          },
          {
            name: 'igs-31se',
            id: 'igs-31se',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/buguangdeng/igs-31se.1.png',
          },
          {
            name: 'igs-32',
            id: 'igs-32',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/buguangdeng/igs-32.png',
          },
          {
            name: 'igs-33',
            id: 'igs-33',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/buguangdeng/igs-33.png',
          },
          {
            name: 'igs-34',
            id: 'igs-34',
            template: 'product-common',
            img: 'http://igstech.com.cn/resources/nva/buguangdeng/igs-34.png',
          },
        ],
      },
      //   {
      //     lable: '帐篷',
      //     products: [
      //       {
      //         name: 'IGS-T01',
      //         id: 'IGS-T01',
      //         template: 'product-common',
      //         img: 'http://igstech.com.cn/resources/nva/zhangpeng/IGS-T01.1.png',
      //       },
      //       {
      //         name: 'IGS-T02',
      //         id: 'IGS-T02',
      //         template: 'product-common',
      //         img: 'http://igstech.com.cn/resources/nva/zhangpeng/IGS-T02.1.png',
      //       },
      //       {
      //         name: 'IGS-T03',
      //         id: 'IGS-T03',
      //         template: 'product-common',
      //         img: 'http://igstech.com.cn/resources/nva/zhangpeng/IGS-T03.1.png',
      //       },
      //     ],
      //   },
      //   配件
      {
        lable: 'Accessories',
        page: 'accessories',
      },
      {
        lable: 'About Us',
        page: 'about-us',
      },
    ]
  },
}
